var map = {
	"./shani_works_1.webp": 1060,
	"./shani_works_10.webp": 7460,
	"./shani_works_11.webp": 2167,
	"./shani_works_12.webp": 6694,
	"./shani_works_14.webp": 8744,
	"./shani_works_15.webp": 4091,
	"./shani_works_16.webp": 3642,
	"./shani_works_17.webp": 7669,
	"./shani_works_18.webp": 5740,
	"./shani_works_19.webp": 7327,
	"./shani_works_2.webp": 8401,
	"./shani_works_20.webp": 223,
	"./shani_works_21.webp": 5340,
	"./shani_works_22.webp": 9609,
	"./shani_works_23.webp": 3582,
	"./shani_works_24.webp": 8867,
	"./shani_works_25.webp": 3104,
	"./shani_works_26.webp": 5933,
	"./shani_works_3.webp": 3670,
	"./shani_works_4.webp": 2027,
	"./shani_works_5.webp": 2856,
	"./shani_works_6.webp": 3605,
	"./shani_works_7.webp": 2506,
	"./shani_works_8.webp": 9487,
	"./shani_works_9.webp": 6044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1323;